// import React, { useState, useEffect } from 'react';
// import { Modal, Button, Table, Form, Spinner } from 'react-bootstrap';
// import { FaSearch, FaTrash } from 'react-icons/fa';
// import { Pencil } from 'lucide-react';
// import Swal from 'sweetalert2';
// import 'sweetalert2/dist/sweetalert2.min.css';

// const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/occupations/';

// const OccupationManager = () => {
//   const [occupations, setOccupations] = useState([]);
//   const [showModal, setShowModal] = useState(false);
//   const [editingItem, setEditingItem] = useState(null);

//   const [mainOccupation, setMainOccupation] = useState('');
//   const [searchTerm, setSearchTerm] = useState('');

//   const [isPageLoading, setIsPageLoading] = useState(false);
//   const [isActionLoading, setIsActionLoading] = useState(false);
//   const [isDeletingId, setIsDeletingId] = useState(null);

//   const token = localStorage.getItem('jwttoken');

//   useEffect(() => {
//     fetchOccupations();
//   }, []);

//   const fetchOccupations = async () => {
//     setIsPageLoading(true);
//     try {
//       const res = await fetch(API_URL, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       if (!res.ok) {
//         const error = await res.json();
//         Swal.fire('Error', error.detail || 'Failed to fetch occupations', 'error');
//         return;
//       }
//       const data = await res.json();
//       setOccupations(data);
//     } catch (err) {
//       Swal.fire('Error', 'Network error', 'error');
//     } finally {
//       setIsPageLoading(false);
//     }
//   };

//   const handleShowModal = (item = null) => {
//     if (item) {
//       setEditingItem(item);
//       setMainOccupation(item.name);
//     } else {
//       setEditingItem(null);
//       setMainOccupation('');
//     }
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setEditingItem(null);
//     setMainOccupation('');
//   };

//   const handleAddOrEdit = async () => {
//     const trimmed = mainOccupation.trim();
//     if (!trimmed) {
//       Swal.fire('Validation', 'Name is required!', 'warning');
//       return;
//     }

//     setIsActionLoading(true);

//     if (editingItem) {
//       // PATCH
//       try {
//         const res = await fetch(`${API_URL}${editingItem.id}/`, {
//           method: 'PATCH',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });
//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to update', 'error');
//           return;
//         }
//         Swal.fire('Updated!', 'Occupation updated successfully.', 'success');
//         fetchOccupations();
//         handleCloseModal();
//       } catch (err) {
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsActionLoading(false);
//       }
//     } else {
//       // POST
//       try {
//         const res = await fetch(API_URL, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//           body: JSON.stringify({ name: trimmed }),
//         });
//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to add', 'error');
//           return;
//         }
//         Swal.fire('Added!', 'Occupation added successfully.', 'success');
//         fetchOccupations();
//         handleCloseModal();
//       } catch (err) {
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsActionLoading(false);
//       }
//     }
//   };

//   const deleteOccupation = async (item) => {
//     const confirm = await Swal.fire({
//       title: 'Are you sure?',
//       text: `Delete "${item.name}"?`,
//       icon: 'warning',
//       showCancelButton: true,
//       confirmButtonColor: '#d33',
//       confirmButtonText: 'Yes, delete it!',
//     });

//     if (confirm.isConfirmed) {
//       setIsDeletingId(item.id);
//       try {
//         const res = await fetch(`${API_URL}${item.id}/`, {
//           method: 'DELETE',
//           headers: {
//             Authorization: `Bearer ${token}`,
//           },
//         });
//         if (!res.ok) {
//           const error = await res.json();
//           Swal.fire('Error', error.detail || 'Failed to delete', 'error');
//           return;
//         }
//         Swal.fire('Deleted!', 'Occupation deleted successfully.', 'success');
//         fetchOccupations();
//       } catch (err) {
//         Swal.fire('Error', 'Network error', 'error');
//       } finally {
//         setIsDeletingId(null);
//       }
//     }
//   };

//   const filteredOccupations = occupations.filter((item) =>
//     item.name.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div>
//       <h4 className="mb-3 text-center">Occupation Management</h4>

//       <div className="d-flex justify-content-between mb-3">
//         <div
//           style={{
//             display: 'flex',
//             alignItems: 'center',
//             position: 'relative',
//             width: '300px',
//           }}
//         >
//           <FaSearch
//             style={{
//               position: 'absolute',
//               left: '10px',
//               color: '#888',
//             }}
//           />
//           <input
//             type="text"
//             placeholder="Search Occupation..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             style={{
//               padding: '8px 10px 8px 35px',
//               border: '1px solid #ddd',
//               borderRadius: '5px',
//               width: '100%',
//             }}
//           />
//         </div>

//         <Button
//           onClick={() => handleShowModal()}
//           style={{
//             background: `linear-gradient(45deg, #FF6600,#B8529E)`,
//             color: 'white',
//             border: 'none',
//           }}
//         >
//           + Add Occupation
//         </Button>
//       </div>

//       {isPageLoading ? (
//         <div className="text-center my-5">
//           <Spinner animation="border" variant="primary" />
//         </div>
//       ) : (
//         <Table striped hover responsive>
//           <thead>
//             <tr>
//               <th>ID</th>
//               <th>Occupation</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {filteredOccupations.length > 0 ? (
//             filteredOccupations.map((item) => (
//               <tr key={item.id}>
//                 <td>{item.id}</td>
//                 <td>{item.name}</td>
//                 <td>
//                   <Button
//                     variant="white"
//                     size="sm"
//                     className="me-2"
//                     style={{
//                       background: 'none',
//                       border: 'none',
//                       color: '#7366ff',
//                       cursor: 'pointer',
//                     }}
//                     onClick={() => handleShowModal(item)}
//                   >
//                     <Pencil size={20} />
//                   </Button>
//                   <Button
//                     variant="white"
//                     size="sm"
//                     style={{
//                       background: 'none',
//                       border: 'none',
//                       color: '#ff5370',
//                       cursor: 'pointer',
//                     }}
//                     onClick={() => deleteOccupation(item)}
//                     disabled={isDeletingId === item.id}
//                   >
//                     {isDeletingId === item.id ? (
//                       <Spinner size="sm" animation="border" />
//                     ) : (
//                       <FaTrash size={20} />
//                     )}
//                   </Button>
//                 </td>
//               </tr>
//             ))
//             ) : (
//               <tr>
//                 <td colSpan="3" className="text-center">
//                   No categories found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </Table>
//       )}

//       <Modal show={showModal} onHide={handleCloseModal}>
//         <Modal.Header closeButton>
//           <Modal.Title>
//             {editingItem ? 'Edit Occupation' : 'Add Occupation'}
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3">
//               <Form.Label>Occupation Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 value={mainOccupation}
//                 onChange={(e) => setMainOccupation(e.target.value)}
//                 placeholder="Enter occupation"
//               />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCloseModal} disabled={isActionLoading}>
//             Close
//           </Button>
//           <Button
//             variant="primary"
//             style={{
//               background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
//               color: 'white',
//               border: 'none',
//             }}
//             onClick={handleAddOrEdit}
//             disabled={isActionLoading}
//           >
//             {isActionLoading ? (
//               <Spinner size="sm" animation="border" />
//             ) : editingItem ? (
//               'Save Changes'
//             ) : (
//               'Add Occupation'
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </div>
//   );
// };

// export default OccupationManager;



import React, { useState, useEffect } from 'react';
import { Modal, Button, Table, Form, Spinner, Pagination } from 'react-bootstrap';
import { FaSearch, FaTrash } from 'react-icons/fa';
import { Pencil } from 'lucide-react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const API_URL = 'https://kaasbackend.vetrinahealthcare.com/master/occupations/';

const OccupationManager = () => {
  const [occupations, setOccupations] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [mainOccupation, setMainOccupation] = useState('');
  const [searchTerm, setSearchTerm] = useState('');

  const [isPageLoading, setIsPageLoading] = useState(false);
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [isDeletingId, setIsDeletingId] = useState(null);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const token = localStorage.getItem('jwttoken');

  useEffect(() => {
    fetchOccupations();
  }, []);

  const fetchOccupations = async () => {
    setIsPageLoading(true);
    try {
      const res = await fetch(API_URL, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) {
        const error = await res.json();
        Swal.fire('Error', error.detail || 'Failed to fetch occupations', 'error');
        return;
      }
      const data = await res.json();
      setOccupations(data);
      setCurrentPage(1); // Reset to first page when data changes
    } catch (err) {
      Swal.fire('Error', 'Network error', 'error');
    } finally {
      setIsPageLoading(false);
    }
  };

  // Filter occupations based on search term
  const filteredOccupations = occupations.filter((item) =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredOccupations.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredOccupations.length / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const handleShowModal = (item = null) => {
    if (item) {
      setEditingItem(item);
      setMainOccupation(item.name);
    } else {
      setEditingItem(null);
      setMainOccupation('');
    }
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingItem(null);
    setMainOccupation('');
  };

  const handleAddOrEdit = async () => {
    const trimmed = mainOccupation.trim();
    if (!trimmed) {
      Swal.fire('Validation', 'Name is required!', 'warning');
      return;
    }

    setIsActionLoading(true);

    if (editingItem) {
      // PATCH
      try {
        const res = await fetch(`${API_URL}${editingItem.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });
        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to update', 'error');
          return;
        }
        Swal.fire('Updated!', 'Occupation updated successfully.', 'success');
        fetchOccupations();
        handleCloseModal();
      } catch (err) {
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsActionLoading(false);
      }
    } else {
      // POST
      try {
        const res = await fetch(API_URL, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ name: trimmed }),
        });
        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to add', 'error');
          return;
        }
        Swal.fire('Added!', 'Occupation added successfully.', 'success');
        fetchOccupations();
        handleCloseModal();
      } catch (err) {
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsActionLoading(false);
      }
    }
  };

  const deleteOccupation = async (item) => {
    const confirm = await Swal.fire({
      title: 'Are you sure?',
      text: `Delete "${item.name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
    });

    if (confirm.isConfirmed) {
      setIsDeletingId(item.id);
      try {
        const res = await fetch(`${API_URL}${item.id}/`, {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!res.ok) {
          const error = await res.json();
          Swal.fire('Error', error.detail || 'Failed to delete', 'error');
          return;
        }
        Swal.fire('Deleted!', 'Occupation deleted successfully.', 'success');
        fetchOccupations();
      } catch (err) {
        Swal.fire('Error', 'Network error', 'error');
      } finally {
        setIsDeletingId(null);
      }
    }
  };

  return (
    <div>
      <h4 className="mb-3 text-center">Occupation Management</h4>

      <div className="d-flex justify-content-between mb-3">
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            position: 'relative',
            width: '300px',
          }}
        >
          <FaSearch
            style={{
              position: 'absolute',
              left: '10px',
              color: '#888',
            }}
          />
          <input
            type="text"
            placeholder="Search Occupation..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={{
              padding: '8px 10px 8px 35px',
              border: '1px solid #ddd',
              borderRadius: '5px',
              width: '100%',
            }}
          />
        </div>

        <Button
          onClick={() => handleShowModal()}
          style={{
            background: 'linear-gradient(45deg, #FF6600,#B8529E)',
            color: 'white',
            border: 'none',
          }}
        >
          + Add Occupation
        </Button>
      </div>

      {isPageLoading ? (
        <div className="text-center my-5">
          <Spinner animation="border" variant="primary" />
        </div>
      ) : (
        <>
          <Table striped hover responsive>
            <thead>
              <tr>
                <th>#</th>
                <th>Occupation</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item, index) => (
                  <tr key={item.id}>
                    <td>{indexOfFirstItem + index + 1}</td>
                    <td>{item.name}</td>
                    <td>
                      <Button
                        variant="white"
                        size="sm"
                        className="me-2"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#7366ff',
                          cursor: 'pointer',
                        }}
                        onClick={() => handleShowModal(item)}
                      >
                        <Pencil size={20} />
                      </Button>
                      <Button
                        variant="white"
                        size="sm"
                        style={{
                          background: 'none',
                          border: 'none',
                          color: '#ff5370',
                          cursor: 'pointer',
                        }}
                        onClick={() => deleteOccupation(item)}
                        disabled={isDeletingId === item.id}
                      >
                        {isDeletingId === item.id ? (
                          <Spinner size="sm" animation="border" />
                        ) : (
                          <FaTrash size={20} />
                        )}
                      </Button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="text-center">
                    No occupations found.
                  </td>
                </tr>
              )}
            </tbody>
          </Table>

          {/* Pagination */}
          {filteredOccupations.length > itemsPerPage && (
            <div className="d-flex justify-content-center mt-3">
              <Pagination>
                <Pagination.First 
                  onClick={() => paginate(1)} 
                  disabled={currentPage === 1} 
                />
                <Pagination.Prev 
                  onClick={() => paginate(currentPage - 1)} 
                  disabled={currentPage === 1} 
                />
                
                {[...Array(totalPages)].map((_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === currentPage}
                    onClick={() => paginate(index + 1)}
                    style={{
                      backgroundColor: index + 1 === currentPage ? 'orange' : '',
                      borderColor: index + 1 === currentPage ? 'orange' : '',
                      color: index + 1 === currentPage ? 'white' : '',
                    }}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                
                <Pagination.Next 
                  onClick={() => paginate(currentPage + 1)} 
                  disabled={currentPage === totalPages} 
                />
                <Pagination.Last 
                  onClick={() => paginate(totalPages)} 
                  disabled={currentPage === totalPages} 
                />
              </Pagination>
            </div>
          )}
        </>
      )}

      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>
            {editingItem ? 'Edit Occupation' : 'Add Occupation'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Occupation Name</Form.Label>
              <Form.Control
                type="text"
                value={mainOccupation}
                onChange={(e) => setMainOccupation(e.target.value)}
                placeholder="Enter occupation"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal} disabled={isActionLoading}>
            Close
          </Button>
          <Button
            variant="primary"
            style={{
              background: 'linear-gradient(135deg, #ff5baf, #7366ff)',
              color: 'white',
              border: 'none',
            }}
            onClick={handleAddOrEdit}
            disabled={isActionLoading}
          >
            {isActionLoading ? (
              <Spinner size="sm" animation="border" />
            ) : editingItem ? (
              'Save Changes'
            ) : (
              'Add Occupation'
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default OccupationManager;